import React, { useContext } from 'react'
import { CollectionHeaderPopups } from '../popups/CollectionHeaderPopups'
import { PopupImage } from '../popups/PopupImage'
import { Context } from '../waxplorer/Waxplorer'
import config from '../../config.json'

export const AssetPreviewImage = ({ asset, title }) => {
    const [, dispatch] = useContext(Context)

    let { name, image, video } = asset

    const toggleImage = () => {
        dispatch({ type: 'FULL_IMAGE', payload: image })
        dispatch({ type: 'FULL_VIDEO', payload: video })
    }

    return (
        <div className="">
            <div className="text-lg 2xl:text-2xl  text-center my-3 md:my-10 px-4">
                <p>{title ? title : name}</p>
            </div>
            {image || video ? (
                <div className="md:my-5 cursor-pointer px-4 ">
                    <PopupImage
                        image={
                            image
                                ? image.includes('http')
                                    ? image
                                    : config.ipfs + image
                                : null
                        }
                        video={
                            video
                                ? video.includes('http')
                                    ? video
                                    : config.ipfs + video
                                : null
                        }
                        toggleImage={toggleImage}
                    />
                </div>
            ) : (
                ''
            )}
            {asset && (
                <div className="mt-7 md:my-10">
                    <CollectionHeaderPopups asset={asset} />
                </div>
            )}
        </div>
    )
}
